import React from "react";
import { HomeOutlined } from "@ant-design/icons";
import { HomePhoneProduct } from "../../../../../types/homePhone";

interface ProductThumbProps {
  product: HomePhoneProduct;
}

const ProductThumb: React.FC<ProductThumbProps> = ({ product }) => (
  <div className="sf-thumb">
    {product.imageUrl ? (
      <img src={product.imageUrl} alt={product.name} />
    ) : (
      <HomeOutlined aria-hidden="true" />
    )}
  </div>
);

export default ProductThumb;
